import { ConnectionStatus, useConnectionStatus } from "@/services/connection"

import { StatusCircle } from "./StatusCircle"

export const StatusButtonInner = ({ status }: { status: ConnectionStatus }) => {
  const appStatus =
    status === ConnectionStatus.IDLE_DISCONNECTED ||
    status === ConnectionStatus.OFFLINE_DISCONNECTED
      ? ConnectionStatus.DISCONNECTED
      : status

  return (
    <div className="flex items-center gap-xs">
      <StatusCircle
        size={10}
        className={
          status === ConnectionStatus.CONNECTED
            ? "fill-(--fg-success-primary)"
            : status === ConnectionStatus.CONNECTING
              ? "fill-(--fg-warning-primary)"
              : "fill-(--fg-error-primary)"
        }
      />
      <p className="text-sm-regular">
        {appStatus[0].toUpperCase() + appStatus.slice(1).toLowerCase()}
      </p>
    </div>
  )
}

export const StatusButton = () => (
  <StatusButtonInner status={useConnectionStatus()} />
)
